import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "crossreferencetype"
    }}>{`CrossReferenceType`}</h1>
    <p>{`Instructional text options for cross reference.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEE_OR_ALSO_BRACKET`}</strong>{` = 1399800172`}</p>
      <p parentName="blockquote">{`Inserts 'See also' in front of the referenced topic if the topic has an associated page reference; inserts 'See' if the topic does not have a page reference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEE`}</strong>{` = 1701729125`}</p>
      <p parentName="blockquote">{`Inserts 'See' in front of the referenced topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEE_ALSO`}</strong>{` = 1399144812`}</p>
      <p parentName="blockquote">{`Inserts 'See also' in front of the referenced topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEE_HEREIN`}</strong>{` = 1397256814`}</p>
      <p parentName="blockquote">{`Inserts 'See herein' in front of the referenced topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SEE_ALSO_HEREIN`}</strong>{` = 1398884466`}</p>
      <p parentName="blockquote">{`Inserts 'See also herein' in front of the referenced topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM_CROSS_REFERENCE`}</strong>{` = 1131639875`}</p>
      <p parentName="blockquote">{`Inserts the specified string in front of the referenced topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM_CROSS_REFERENCE_BEFORE`}</strong>{` = 1131639906`}</p>
      <p parentName="blockquote">{`Inserts the specified string and the specified before cross reference separator in front of the referenced topic. If no before cross reference separator is specified, inserts a space.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM_CROSS_REFERENCE_AFTER`}</strong>{` = 1131639905`}</p>
      <p parentName="blockquote">{`Inserts the specified following topic separator and the specified string after the referenced topic. If no following topic separator is specified, inserts a space.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      